import { z } from 'zod';
import { IdSchema, TimestampSchema } from './common.js';
/** Records a signature can be attached to. */
export const SignatureTargetTypeSchema = z.enum(['job_file', 'inspection', 'milestone', 'project']);
export const SignaturePurposeSchema = z.enum([
    'work_authorization',
    'completion',
    'drying_log',
    'inspection',
    'other',
]);
export const SignerRoleSchema = z.enum(['customer', 'adjuster', 'technician', 'other']);
/**
 * A captured sign-off (specification 9.1, 8.18). The signature image is a private document
 * uploaded against the same record; the record says who signed, as what, and for what.
 * Immutable once captured.
 */
export const SignatureRecordSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    targetType: SignatureTargetTypeSchema,
    targetId: IdSchema,
    purpose: SignaturePurposeSchema,
    signerName: z.string(),
    signerRole: SignerRoleSchema,
    documentId: IdSchema,
    notes: z.string().nullable(),
    signedAt: TimestampSchema,
    capturedByMembershipId: IdSchema,
    createdAt: TimestampSchema,
});
export const CaptureSignatureRequestSchema = z.strictObject({
    targetType: SignatureTargetTypeSchema,
    targetId: IdSchema,
    purpose: SignaturePurposeSchema,
    signerName: z.string().trim().min(1).max(200),
    signerRole: SignerRoleSchema,
    /** An image document already uploaded against the same target. */
    documentId: IdSchema,
    notes: z.string().trim().max(1000).nullable().default(null),
});
export const SignatureListQuerySchema = z.strictObject({
    targetType: SignatureTargetTypeSchema,
    targetId: IdSchema,
    purpose: SignaturePurposeSchema.optional(),
});
export const SignatureListSchema = z.strictObject({ items: z.array(SignatureRecordSchema) });
